export enum Cmg1003SectionTypes {
  borrowerInformation = 0,
  loanInformation = 1,
  propertyInformation = 2,
  employmentInformation = 3,
  assetsCreditLiabilitiesInformation = 4,
  transactionDetails = 5,
  declarations = 6,
  gmiAndMilitaryServiceInformation = 7,
  continuationSheet = 8,
  compensationInformation = 9,
  aus = 10,
  loanOfficer = 11,
  loanFeatures = 12,
  cA885PaymentScenario = 13,
  housingExpenses = 14,
}

export enum CreditSectionTypes {
  requestCreditReport = 0,
  importLiabilities = 1,
}

export enum Cmg1008SectionTypes {
  borrowerandPropertyInformation = 0,
  mortgageInformation = 1,
  underwritingInformation = 2,
  sellerInformation = 3,
}

export enum MarketingAutomationSectionTypes {
  marketingAutomations = 'Marketing Automations',
  pastFundedLoans = 'Past Funded Loans',
}
